import { render, staticRenderFns } from "./IsciFilter.vue?vue&type=template&id=4885a496&scoped=true"
import script from "./IsciFilter.vue?vue&type=script&lang=js"
export * from "./IsciFilter.vue?vue&type=script&lang=js"
import style0 from "./IsciFilter.vue?vue&type=style&index=0&id=4885a496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885a496",
  null
  
)

export default component.exports